export default __webpack_public_path__ + "static/media/687.465c2851.gif";